import { defineMessages } from 'react-intl'

export const messages = defineMessages({
  recurrenceSettingsEnabler: {
    id: 'admin/promotions.form.recurrence.enabler',
  },
  weekdays: {
    id: 'admin/promotions.form.recurrence.weekdays',
  },
  allWeekdays: {
    id: 'admin/promotions.form.recurrence.weekdays.any',
  },
  specificWeekdays: {
    id: 'admin/promotions.form.recurrence.weekdays.specific',
  },
  monday: {
    id: 'admin/promotions.form.recurrence.weekdays.monday',
  },
  tuesday: {
    id: 'admin/promotions.form.recurrence.weekdays.tuesday',
  },
  wednesday: {
    id: 'admin/promotions.form.recurrence.weekdays.wednesday',
  },
  thursday: {
    id: 'admin/promotions.form.recurrence.weekdays.thursday',
  },
  friday: {
    id: 'admin/promotions.form.recurrence.weekdays.friday',
  },
  saturday: {
    id: 'admin/promotions.form.recurrence.weekdays.saturday',
  },
  sunday: {
    id: 'admin/promotions.form.recurrence.weekdays.sunday',
  },
})
